export const selectBarbers = state => state.barbers;
export const selectAuth = state => state.auth;
export const selectErrors = state => state.errors;
export const selectLoaders = state => state.loaders;
export const selectBookings = state => state.bookings;
export const selectProducts = state => state.products;
export const selectOrders = state => state.orders;